import { render, staticRenderFns } from "./workerPressList.vue?vue&type=template&id=2046b792&"
import script from "./workerPressList.vue?vue&type=script&lang=js&"
export * from "./workerPressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports